export default __webpack_public_path__ + "static/media/2.c8691d67.png";